import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Add this event listener to handle page refresh errors
window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled Promise rejection:', event.reason);

  // If it's a network-related error during page refresh
  if (
    event.reason instanceof Error &&
    (event.reason.message.includes('Network Error') ||
      event.reason.message.includes('Failed to fetch') ||
      event.reason.message.includes('Keycloak initialization timed out'))
  ) {
    console.warn(
      'Network/Auth error detected during page operation, attempting recovery...'
    );

    // Clear potentially stale tokens
    localStorage.removeItem('keycloakToken');
    localStorage.removeItem('refreshToken');

    // Prevent the default browser error handling
    event.preventDefault();
  }
});

bootstrapApplication(AppComponent, appConfig).catch((err) => {
  console.error('Bootstrap error:', err);
  // Handle bootstrap errors gracefully
  if (err.message && err.message.includes('502')) {
    console.warn('502 error detected, clearing cache and retrying...');
    localStorage.clear();
    sessionStorage.clear();
    // Reload the page after a short delay
    setTimeout(() => window.location.reload(), 1000);
  }
});
